import { Dictionary } from '../../../types/dictionary';

export interface IndexedDbResourceLocation {
  databaseName: string;
  objectStoreName: string;
  key?: string;
  params?: Dictionary<unknown>;
}
